import { animatePulse } from "@/src/utils/animation.utils";
import { useEffect, useRef } from "react";
import { Animated, View } from "react-native";

const NotificationSkeletonRow = () => {
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    animatePulse(opacity);
  }, []);

  return (
    <Animated.View style={{ opacity }}>
      <View className="bg-chalk mb-2 rounded-2xl border border-ash-3">
        <View className="flex-row items-center px-4 py-2">
          {/* Avatar */}
          <View className="mr-3 h-10 w-10 rounded-full bg-ash-3" />

          {/* Two text lines */}
          <View className="flex-1 gap-2">
            <View className="h-3 w-full rounded-md bg-ash-3" />
            <View className="h-3 w-2/3 rounded-md bg-ash-3" />
          </View>

          {/* Time */}
          <View className="ml-3 h-3 w-10 rounded-md bg-ash-3" />
        </View>
      </View>
    </Animated.View>
  );
};

const NotificationSkeleton = ({ count = 6 }: { count?: number }) => (
  <View className="py-4">
    {Array.from({ length: count }).map((_, index) => (
      <NotificationSkeletonRow key={index} />
    ))}
  </View>
);

export default NotificationSkeleton;
